/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetHospitalsSummaryQueryResponse,
  GetHospitalsSummaryQueryParams,
} from '../types/GetHospitalsSummary'

function getGetHospitalsSummaryUrl() {
  const res = { method: 'GET', url: `/api/v1/hospital/summary/` as const }
  return res
}

/**
 * @summary Hospitals list summary (count of filtered rows)
 * {@link /api/v1/hospital/summary/}
 */
export async function getHospitalsSummary(
  params?: GetHospitalsSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetHospitalsSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetHospitalsSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
